const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const U=v=>String(v||'MISSING').toUpperCase();

export function deriveTimingContext(research={},macro={}){
 const market=research?.market||{},rocket=research?.rocketEvidence||{},grass=research?.grasshopperEvidence||{};
 const horse=macro?.horse||{},pig=macro?.pig||{};
 const marketVerified=U(market?.status)==='VERIFIED';
 const distance=N(market?.distance120wPct),vol=N(market?.annualizedVolatilityPct);

 const pricePosition=!marketVerified||distance==null?'MISSING':distance>=30?'EXTENDED_ABOVE_120W':distance<=-20?'BELOW_120W':'NORMAL_120W_CONTEXT';
 const volatility=!marketVerified||vol==null?'MISSING':vol>=100?'VERY_HIGH_VOLATILITY':vol>=70?'ELEVATED_VOLATILITY':'NORMAL_VOLATILITY';
 const repricing=U(rocket?.state);
 const elasticity=U(grass?.state);
 const macroState=U(horse?.state);
 const sectorClarity=U(pig?.state);

 const cautions=[];
 const supports=[];

 if(pricePosition==='EXTENDED_ABOVE_120W')cautions.push('PRICE_EXTENDED_ABOVE_120W');
 if(['VERY_HIGH_VOLATILITY','ELEVATED_VOLATILITY'].includes(volatility))cautions.push(volatility);
 if(['NEGATIVE_REPRICING','NEGATIVE_REVISION_DIVERGENCE'].includes(repricing))cautions.push('NEGATIVE_REPRICING');
 if(['HIGH_ELASTICITY','ELEVATED_ELASTICITY','ELASTICITY_RISK_PROXY','TIGHT_LIQUIDITY_PROXY'].includes(elasticity))cautions.push('ELASTICITY_RISK');
 if(['RISK_OFF','DETERIORATING'].includes(macroState))cautions.push('MACRO_RISK');
 if(sectorClarity==='MUDDY')cautions.push('SECTOR_MUDDY');

 if(pricePosition==='NORMAL_120W_CONTEXT')supports.push('PRICE_NOT_EXTENDED');
 if(volatility==='NORMAL_VOLATILITY')supports.push('VOLATILITY_NOT_ELEVATED');
 if(['POSITIVE_REPRICING','POSITIVE_REVISION_DIVERGENCE'].includes(repricing))supports.push('POSITIVE_REPRICING');
 if(['LOWER_ELASTICITY','DEEP_LIQUIDITY_PROXY'].includes(elasticity))supports.push('LIQUIDITY_SUPPORT');
 if(['RISK_ON','IMPROVING'].includes(macroState))supports.push('MACRO_SUPPORT');
 if(sectorClarity==='CLEAR')supports.push('SECTOR_CLEAR');

 let state='REVIEW';
 if(marketVerified&&distance!=null&&vol!=null){
  if(cautions.length>=2)state='CAUTION_CONTEXT';
  else if(cautions.length===0&&supports.length>=3)state='SUPPORTIVE_CONTEXT';
  else state='MIXED_CONTEXT';
 }

 return{
  status:state==='REVIEW'?'REVIEW':'EVIDENCE',
  state,
  pricePosition,
  volatility,
  repricing,
  elasticity,
  macroState,
  sectorClarity,
  distance120wPct:distance,
  annualizedVolatilityPct:vol,
  cautions,
  supports,
  capitalPermission:'NONE',
  note:'Timing Context combines verified price position, volatility, repricing, elasticity and live macro/sector context. It does not create BUY/SELL, entry permission or capital permission.'
 };
}
